// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__L0b8B","videoPlayer":"VideoHero_videoPlayer__ZHk9b","content":"VideoHero_content__rhLPi"};